export default {
  id: 'invoices',
  title: 'Invoices',
  category: 'Admin',
  summary: 'Create, manage, and track customer invoices for labor, travel, other billable amounts, and cost-plus funding summaries.',
  overview: 'The Invoices area lists existing invoices and highlights recommended or uninvoiced work. Creation starts with a wizard (Labor / Travel / Other). Invoice details adapt to the contract: T&M labor invoices show standard line items, while prime cost-plus invoices show a Contract Funding Breakdown with direct, indirect, and fee charges plus supporting labor schedules.',
  howItWorks: [
    'Labor invoices pull from approved billable time entries (T&M) or cost-plus labor charges depending on the project.',
    'Travel invoices bill approved travel expense amounts to customers.',
    'Other invoices cover miscellaneous billable line items.',
    'Prime cost-plus invoice details load a cost-plus summary: funding breakdown (cost/fee/total, % billed, cumulative), period charges (direct labor, subs/consultants, indirect, fee), and supporting schedules.',
    'Where allowed, you can edit hours or remove lines on cost-plus schedules; totals refresh after changes.',
    'Balance sync and QuickBooks actions keep accounting systems aligned when integrations are configured.'
  ],
  actions: [
    {
      name: 'Create invoice',
      description: 'Opens the invoice type wizard (Labor / Travel / Other).'
    },
    {
      name: 'Open invoice details',
      description: 'View or edit line items, preview the invoice, and manage status. Cost-plus primes show the funding breakdown view instead of the standard T&M labor table.'
    },
    {
      name: 'Edit hours / remove lines (cost-plus)',
      description: 'When you have manage rights, adjust schedule hours or remove lines; the cost-plus summary recalculates.'
    },
    {
      name: 'Mark paid',
      description: 'Records that payment was received for the invoice.'
    },
    {
      name: 'Sync balances / QuickBooks',
      description: 'Refreshes payment or accounting state from connected systems.'
    },
    {
      name: 'Review uninvoiced hours',
      description: 'Identifies approved billable time that has not yet been invoiced.'
    }
  ],
  tips: [
    'Approve timesheets and expense reports before expecting them to appear in invoice creation.',
    'For cost-plus invoices, resolve funding obligation mismatches on the project before billing so breakdowns match customer funding.',
    'Use recommended invoices and uninvoiced hours panels to avoid missing billable work.'
  ],
  related: ['invoice-create-wizard', 'funding-obligations', 'contracts', 'timesheet', 'quickbooks']
};



// WEBPACK FOOTER //
// ./client/help/content/invoices.js